import React, { useState, useEffect } from "react";
import { requestData } from "../services/requests";
import { arrayEstados, organizarPorEstado } from "../services/funcoesAuxiliares";
import { toast } from 'react-toastify';
import Header from './header';
import DeletarGestor from "./Modals/DeletarGestor";
import CadastraGestor from "./Modals/CadastraGestor";
import DeletarCarteiras from "./Modals/DeletarCarteiras";
import VendedoresDrawer from "./VendedoresDrawer";
import ListaNegraDrawer from "./ListaNegraDrawer";
import { 
  Users, 
  Plus, 
  Trash2, 
  UserCheck, 
  UserX, 
  Settings, 
  Calendar,
  Filter,
  AlertTriangle,
  UserCog,
  Link,
  Copy,
  Eye,
  EyeOff,
  UserMinus,
  UserPlus,
  Shield
} from "lucide-react";
import api from "../services/requests";

const VisualizarGestores = () => {
  const [gestores, setGestores] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [gestorId, setGestorId] = useState('');
  const [dataInicial, setDataInicial] = useState('');
  const [idGestor, setIdGestor] = useState('');
  const [dataFinal, setDataFinal] = useState('');
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [telefone, setTelefone] = useState('');
  const [cpf, setCpf] = useState('');
  const [role, setRole] = useState('');
  const [estado, setEstado] = useState('');
  const [pass, setPass] = useState('');
  const arrayStatus = ["Selecione um Status", "Recepcionada", "Validada", "Renovação", "Expirada", "Cancelada"];
  const newArrayGestores = [{name: 'Selecione um gestor'}, ...gestores];

  const props = {
    email,
    setEmail,
    telefone,
    setTelefone,
    nome,
    setNome,
    cpf,
    setCpf,
    role,
    setRole,
    estado,
    setEstado,
    pass,
    setPass,
  }

  const [exibirModalDeletarGestores, setExibirModalDeletarGestores] = useState(false);
  const [exibirModalCadastrarGestores, setExibirModalCadastrarGestores] = useState(false);
  const [exibirModalDeletarCarteiras, setExibirModalDeletarCarteiras] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedGestor, setSelectedGestor] = useState(null);
  const [vendedores, setVendedores] = useState([]);
  const [showLinks, setShowLinks] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [isListaNegraOpen, setIsListaNegraOpen] = useState(false);

  const handleOpenModalDeletarGestores = (id) => {
    setExibirModalDeletarGestores(prev => !prev);
    setIdGestor(id);
  }
  
  const handleOpenModalCadastrarGestores = () => setExibirModalCadastrarGestores(prev => !prev);

  const handleOpenModalDeletarCarteiras = () => setExibirModalDeletarCarteiras(prev => !prev);

  const handleClose = () => { 
    window.location.reload();
  }

  const BloquearGestor = async (id, bloqueio) => {
    try {
      await api.put(`/user/bloquear/${id}`, { bloqueio });
      alert('Gestor bloqueado!');
      window.location.reload();
    }
    catch (e) {
      console.log(e);
    }
  }

  const DesbloquearGestor = async (id, desbloqueio) => {
    try {
      await api.put(`/user/desbloquear/${id}`, { desbloqueio });
      alert('Gestor desbloqueado com sucesso!');
      window.location.reload();
    }
    catch (e) {
      console.log(e);
    }
  }

  const excluirGestor = async (id) => {
    try {
      await api.delete(`/user/deletar/${id}`);
      window.location.reload();
      setExibirModalDeletarGestores(prev => !prev);
    } catch (error) {
      console.log(error);
    }
  }

  const deletarCarteiras = async (dataInicial, dataFinal, status, gestorId ) => {
    try {
      if (dataFinal !== '') {
        await api.delete(`/carteiras/deletar/data/?dataInicial=${dataInicial}&dataFinal=${dataFinal}`);
        alert('Carteira excluida com sucesso!');
        window.location.reload();
      }
      if (status !== '') {
        await api.delete(`/carteiras/deletar/status/?status=${status}`);
        alert('Carteira excluida com sucesso!');
        window.location.reload();
      }
      if (gestorId !== '') {
        await api.delete(`/carteiras/deletar/gestor/?id=${gestorId}`);
        alert('Carteira excluida com sucesso!');
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    }
  
  }

  const cadastroGestores = async (nome, pass, email, cpf, telefone, role, estado) => {
    try {
      await api.post('/user/cadastrar/gestor', {
        nome,
        pass,
        email,
        cpf,
        telefone,
        role,
        estado,
      });
      toast.success('Gestor cadastrado com sucesso!');
      setExibirModalCadastrarGestores(prev => !prev);
      window.location.reload();
    } catch (error) {
      console.log(error);
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Erro ao cadastrar gestor');
      }
    }
  }

  const obterGestores = async () => {
    try {
      const gestoresData = await requestData('/user/all');
      console.log('Gestores carregados:', gestoresData);
      setGestores(gestoresData);
    } catch (error) {
      console.error('Erro ao carregar gestores:', error);
    }
  }

  const obterVendedores = async () => {
    try {
      const vendedoresData = await requestData('/vendedores/all');
      setVendedores(vendedoresData);
    } catch (error) {
      console.error('Erro ao buscar colaboradores:', error);
    }
  }

  const handleOpenDrawer = (gestor) => {
    console.log('Abrindo drawer para gestor:', gestor);
    setSelectedGestor(gestor);
    setIsDrawerOpen(true);
    obterVendedores();
  }

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedGestor(null);
  }

  const handleOpenListaNegra = () => {
    setIsListaNegraOpen(true);
  }

  const handleCloseListaNegra = () => {
    setIsListaNegraOpen(false);
  }

  const transferirVendedor = async (vendedorId, novoGestorId) => {
    if (!novoGestorId) return;
    
    setIsLoading(true);
    try {
      await api.put(`/vendedores/transferir/${vendedorId}`, { 
        gestorId: novoGestorId 
      });
      toast.success('Colaborador transferido com sucesso!');
      obterVendedores();
    } catch (error) {
      console.error('Erro ao transferir colaborador:', error);
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Erro ao transferir colaborador');
      }
    } finally {
      setIsLoading(false);
    }
  }

  const bloquearVendedor = async (vendedorId) => {
    setIsLoading(true);
    try {
      await api.put(`/vendedores/${vendedorId}`, { 
        ativo: false 
      });
      toast.success('Colaborador bloqueado com sucesso!');
      obterVendedores();
    } catch (error) {
      console.error('Erro ao bloquear colaborador:', error);
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Erro ao bloquear vendedor');
      }
    } finally {
      setIsLoading(false);
    }
  }

  const desbloquearVendedor = async (vendedorId) => {
    setIsLoading(true);
    try {
      await api.put(`/vendedores/${vendedorId}`, { 
        ativo: true 
      });
      toast.success('Colaborador desbloqueado com sucesso!');
      obterVendedores();
    } catch (error) {
      console.error('Erro ao desbloquear colaborador:', error);
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Erro ao desbloquear colaborador');
      }
    } finally {
      setIsLoading(false);
    }
  }

  const toggleShowLink = (vendedorId) => {
    setShowLinks(prev => ({
      ...prev,
      [vendedorId]: !prev[vendedorId]
    }));
  }

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success('Link copiado para a área de transferência!');
    } catch (error) {
      console.error('Erro ao copiar:', error);
      toast.error('Erro ao copiar link');
    }
  }

  const renovarToken = async (vendedorId) => {
    setIsLoading(true);
    try {
      // Criar nova data de expiração (1 ano a partir de agora)
      const novaDataExpiracao = new Date();
      novaDataExpiracao.setFullYear(novaDataExpiracao.getFullYear() + 1);
      
      await api.put(`/vendedores/${vendedorId}`, { 
        token_expira_em: novaDataExpiracao.toISOString()
      });
      toast.success('Token renovado com sucesso!');
      obterVendedores();
    } catch (error) {
      console.error('Erro ao renovar token:', error);
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error('Erro ao renovar token');
      }
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    obterGestores();
  }, []);

  const gestoresOrganizados = organizarPorEstado(arrayEstados, gestores);
  const location = window.location.href.split('/')[3];
  return (
    <>
      <Header location={location} />
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="max-w-7xl mx-auto p-6 space-y-6">
          
          {/* Header da página */}
          <div className="bg-white rounded-xl shadow-lg p-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Users className="w-8 h-8 text-blue-600" />
                <h1 className="text-3xl font-bold text-gray-800">Gestão de Gestores</h1>
              </div>
              <button
                className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors flex items-center gap-2"
                onClick={handleOpenModalCadastrarGestores}
              >
                <Plus className="w-5 h-5" />
                Cadastrar Gestor
              </button>
            </div>
          </div>

          {/* Botão da Lista Negra */}
          <div className="bg-white rounded-xl shadow-lg p-4">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Shield className="w-6 h-6 text-red-600" />
                <div>
                  <h2 className="text-lg font-semibold text-gray-800">Lista Negra</h2>
                  <p className="text-sm text-gray-500">Gerencie CPFs bloqueados no sistema</p>
                </div>
              </div>
              <button
                className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2"
                onClick={handleOpenListaNegra}
              >
                <AlertTriangle className="w-4 h-4" />
                Gerenciar Lista Negra
              </button>
            </div>
          </div>

          {/* Seção de exclusão de carteiras */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="bg-red-600 px-6 py-4">
              <div className="flex items-center gap-2">
                <AlertTriangle className="w-6 h-6 text-white" />
                <h2 className="text-xl font-semibold text-white">Excluir Carteiras</h2>
              </div>
            </div>
            
            <div className="p-6 space-y-4">
              {/* Por Data */}
              <div className="bg-gray-50 rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <Calendar className="w-5 h-5 text-gray-600" />
                    <span className="font-medium text-gray-700">Por Data</span>
                    <div className="flex items-center gap-2">
                      <input
                        value={dataInicial}
                        onChange={({ target: { value } }) => setDataInicial(value)}
                        type="date"
                        className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                      />
                      <span className="text-gray-500">até</span>
                      <input
                        value={dataFinal}
                        onChange={({ target: { value } }) => setDataFinal(value)}
                        type="date"
                        className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                      />
                    </div>
                  </div>
                  <button
                    className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2"
                    onClick={handleOpenModalDeletarCarteiras}
                  >
                    <Trash2 className="w-4 h-4" />
                    Excluir
                  </button>
                </div>
              </div>

              {/* Por Status */}
              <div className="bg-gray-50 rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <Filter className="w-5 h-5 text-gray-600" />
                    <span className="font-medium text-gray-700">Por Status</span>
                    <select
                      onChange={(e) => setSelectedStatus(e.target.value)}
                      className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                    >
                      {arrayStatus.map((status, index) => (
                        <option key={index + 1} value={status}>
                          {status}
                        </option>
                      ))}
                    </select>
                  </div>
                  <button
                    className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2"
                    onClick={handleOpenModalDeletarCarteiras}
                  >
                    <Trash2 className="w-4 h-4" />
                    Excluir
                  </button>
                </div>
              </div>

              {/* Por Gestor */}
              <div className="bg-gray-50 rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-4">
                    <UserCog className="w-5 h-5 text-gray-600" />
                    <span className="font-medium text-gray-700">Por Gestor</span>
                    <select
                      onChange={(e) => setGestorId(e.target.value)}
                      className="px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
                    >
                      {newArrayGestores.map((gestor, index) => (
                        <option key={index} value={gestor.id}>
                          {gestor.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <button
                    className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2"
                    onClick={handleOpenModalDeletarCarteiras}
                  >
                    <Trash2 className="w-4 h-4" />
                    Excluir
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Lista de Gestores */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden">
            <div className="bg-blue-600 px-6 py-4">
              <h2 className="text-xl font-semibold text-white">Gestores Cadastrados</h2>
            </div>
            
            <div className="p-6">
              {gestores.length === 0 ? (
                <div className="text-center py-12">
                  <Users className="w-16 h-16 mx-auto mb-4 text-gray-300" />
                  <h3 className="text-lg font-medium text-gray-500 mb-2">Nenhum gestor encontrado</h3>
                  <p className="text-gray-400 mb-6">Cadastre o primeiro gestor para começar</p>
                  <button
                    className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors flex items-center gap-2 mx-auto"
                    onClick={handleOpenModalCadastrarGestores}
                  >
                    <Plus className="w-5 h-5" />
                    Cadastrar Primeiro Gestor
                  </button>
                </div>
              ) : (
                gestoresOrganizados.length > 0 ? (
                  gestoresOrganizados.map(
                    (e, index) =>
                      Object.values(e).length !== 0 && (
                        <div key={index + 1} className="mb-6">
                          <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b border-gray-200">
                            {Object.keys(e)}
                          </h3>
                          <div className="grid gap-4">
                            {Object.values(e).map((h) =>
                              h.map((j) => (
                                <div
                                  key={j.id}
                                  className="bg-gray-50 rounded-lg p-4 flex items-center justify-between hover:bg-gray-100 transition-colors"
                                >
                                  <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                                      <Users className="w-5 h-5 text-blue-600" />
                                    </div>
                                    <div>
                                      <h4 className="font-medium text-gray-800">{j.name}</h4>
                                      <p className="text-sm text-gray-500">{j.email}</p>
                                    </div>
                                    {j.bloqueio && (
                                      <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded-full">
                                        Bloqueado
                                      </span>
                                    )}
                                  </div>
                                  
                                  <div className="flex items-center gap-2">
                                    <button
                                      className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2"
                                      onClick={() => handleOpenDrawer(j)}
                                    >
                                      <Settings className="w-4 h-4" />
                                      Gerenciar Colaboradores
                                    </button>
                                    
                                    {j.bloqueio === true ? (
                                      <button
                                        className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2"
                                        onClick={() => DesbloquearGestor(j.id, false)}
                                      >
                                        <UserCheck className="w-4 h-4" />
                                        Desbloquear
                                      </button>
                                    ) : (
                                      <button
                                        className="bg-yellow-600 hover:bg-yellow-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2"
                                        onClick={() => BloquearGestor(j.id, true)}
                                      >
                                        <UserX className="w-4 h-4" />
                                        Bloquear
                                      </button>
                                    )}
                                    
                                    <button
                                      className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2"
                                      onClick={() => handleOpenModalDeletarGestores(j.id)}
                                    >
                                      <Trash2 className="w-4 h-4" />
                                      Excluir
                                    </button>
                                  </div>
                                </div>
                              ))
                            )}
                          </div>
                        </div>
                      )
                  )
                ) : (
                  // Fallback: mostrar todos os gestores sem organização por estado
                  <div className="mb-6">
                    <h3 className="text-lg font-semibold text-gray-800 mb-4 pb-2 border-b border-gray-200">
                      Todos os Gestores
                    </h3>
                    <div className="grid gap-4">
                      {gestores.map((j) => (
                        <div
                          key={j.id}
                          className="bg-gray-50 rounded-lg p-4 flex items-center justify-between hover:bg-gray-100 transition-colors"
                        >
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center">
                              <Users className="w-5 h-5 text-blue-600" />
                            </div>
                            <div>
                              <h4 className="font-medium text-gray-800">{j.name}</h4>
                              <p className="text-sm text-gray-500">{j.email}</p>
                              {j.estado && (
                                <p className="text-xs text-gray-400">Estado: {j.estado}</p>
                              )}
                            </div>
                            {j.bloqueio && (
                              <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded-full">
                                Bloqueado
                              </span>
                            )}
                          </div>
                          
                          <div className="flex items-center gap-2">
                            <button
                              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2"
                              onClick={() => handleOpenDrawer(j)}
                            >
                              <Settings className="w-4 h-4" />
                              Gerenciar
                            </button>
                            
                            {j.bloqueio === true ? (
                              <button
                                className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2"
                                onClick={() => DesbloquearGestor(j.id, false)}
                              >
                                <UserCheck className="w-4 h-4" />
                                Desbloquear
                              </button>
                            ) : (
                              <button
                                className="bg-yellow-600 hover:bg-yellow-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2"
                                onClick={() => BloquearGestor(j.id, true)}
                              >
                                <UserX className="w-4 h-4" />
                                Bloquear
                              </button>
                            )}
                            
                            <button
                              className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg font-medium transition-colors flex items-center gap-2"
                              onClick={() => handleOpenModalDeletarGestores(j.id)}
                            >
                              <Trash2 className="w-4 h-4" />
                              Excluir
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>


        {/* Drawer da Lista Negra */}
        <ListaNegraDrawer isOpen={isListaNegraOpen} onClose={handleCloseListaNegra} />

        {/* Drawer para gerenciar vendedores */}
        <VendedoresDrawer isOpen={isDrawerOpen} onClose={handleCloseDrawer}>
          <div className="space-y-4">
            <div className="border-b border-gray-200 pb-4">
              <h3 className="text-base sm:text-lg font-semibold text-gray-800">
                Gerenciar Colaboradores - {selectedGestor?.name}
              </h3>
              <p className="text-xs sm:text-sm text-gray-500">
                Gerencie colaboradores, links de criação e transferências
              </p>
            </div>

            {/* Lista de vendedores do gestor */}
            <div className="space-y-3">
              <div className="flex items-center justify-between">
                <h4 className="font-medium text-gray-700 text-sm sm:text-base">Colaboradores</h4>
                <span className="text-xs sm:text-sm text-gray-500">
                  {vendedores.filter(v => v.gestor_id === selectedGestor?.id).length} colaborador(es)
                </span>
              </div>
              
              {vendedores
                .filter(v => v.gestor_id === selectedGestor?.id)
                .map((vendedor) => (
                  <div key={vendedor.id} className="bg-white border border-gray-200 rounded-lg p-3 shadow-sm">
                    {/* Header do vendedor */}
                    <div className="flex items-start justify-between mb-3">
                      <div className="flex items-start gap-2 sm:gap-3 flex-1 min-w-0">
                        <div className="w-8 h-8 sm:w-10 sm:h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                          <Users className="w-4 h-4 sm:w-5 sm:h-5 text-blue-600" />
                        </div>
                        <div className="min-w-0 flex-1">
                          <h5 className="font-medium text-gray-800 text-sm sm:text-base truncate">{vendedor.nome}</h5>
                          <p className="text-xs sm:text-sm text-gray-500">CPF: {vendedor.cpf}</p>
                          {vendedor.telefone && (
                            <p className="text-xs sm:text-sm text-gray-500">Tel: {vendedor.telefone}</p>
                          )}
                          <p className="text-xs text-gray-400">
                            Criado em: {new Date(vendedor.created_at).toLocaleDateString('pt-BR')}
                          </p>
                        </div>
                      </div>
                      
                      {/* Status badge */}
                      <div className="flex items-center gap-2 flex-shrink-0">
                        {vendedor.ativo ? (
                          <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded-full">
                            Ativo
                          </span>
                        ) : (
                          <span className="bg-red-100 text-red-800 text-xs px-2 py-1 rounded-full">
                            Bloqueado
                          </span>
                        )}
                      </div>
                    </div>

                    {/* Link de criação */}
                    <div className="mb-3 p-2 sm:p-3 bg-gray-50 rounded-lg">
                      <div className="flex items-center justify-between mb-2">
                        <div className="flex items-center gap-1 sm:gap-2">
                          <Link className="w-3 h-3 sm:w-4 sm:h-4 text-gray-600" />
                          <span className="text-xs sm:text-sm font-medium text-gray-700">Link de Criação</span>
                        </div>
                        <button
                          onClick={() => toggleShowLink(vendedor.id)}
                          className="flex items-center gap-1 text-blue-600 hover:text-blue-700 text-xs sm:text-sm"
                        >
                          {showLinks[vendedor.id] ? <EyeOff className="w-3 h-3 sm:w-4 sm:h-4" /> : <Eye className="w-3 h-3 sm:w-4 sm:h-4" />}
                          <span className="hidden sm:inline">{showLinks[vendedor.id] ? 'Ocultar' : 'Ver'}</span>
                        </button>
                      </div>
                      
                      {/* Informações do token */}
                      <div className="text-xs text-gray-500 mb-2">
                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1">
                          <p className="truncate">Expira: {vendedor.token_expira_em ? new Date(vendedor.token_expira_em).toLocaleDateString('pt-BR') : 'Não definido'}</p>
                          <button
                            onClick={() => renovarToken(vendedor.id)}
                            disabled={isLoading}
                            className="px-2 py-1 text-xs bg-blue-100 text-blue-700 hover:bg-blue-200 rounded transition-colors disabled:opacity-50 w-fit"
                          >
                            Renovar
                          </button>
                        </div>
                        {vendedor.token_expira_em && new Date(vendedor.token_expira_em) < new Date() && (
                          <p className="text-red-600 font-medium text-xs">⚠️ Token expirado!</p>
                        )}
                      </div>
                      
                      {showLinks[vendedor.id] && (
                        <div className="mt-2">
                          <div className="flex items-center gap-1 sm:gap-2">
                            <input
                              type="text"
                              value={vendedor.creationLink || `${window.location.origin}/criar-carteira/${vendedor.token}`}
                              readOnly
                              className="flex-1 px-2 sm:px-3 py-1 sm:py-2 text-xs sm:text-sm border border-gray-300 rounded bg-white min-w-0"
                            />
                            <button
                              onClick={() => copyToClipboard(vendedor.creationLink || `${window.location.origin}/criar-carteira/${vendedor.token}`)}
                              className="p-1 sm:p-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded flex-shrink-0"
                            >
                              <Copy className="w-3 h-3 sm:w-4 sm:h-4" />
                            </button>
                          </div>
                        </div>
                      )}
                    </div>

                    {/* Ações do vendedor */}
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2">
                      <div className="flex items-center gap-1 sm:gap-2">
                        {/* Bloquear/Desbloquear */}
                        {vendedor.ativo ? (
                          <button
                            onClick={() => bloquearVendedor(vendedor.id)}
                            disabled={isLoading}
                            className="flex items-center gap-1 px-2 sm:px-3 py-1 text-xs sm:text-sm bg-red-100 text-red-700 hover:bg-red-200 rounded-lg transition-colors disabled:opacity-50"
                          >
                            <UserMinus className="w-3 h-3 sm:w-4 sm:h-4" />
                            <span className="hidden sm:inline">Bloquear</span>
                          </button>
                        ) : (
                          <button
                            onClick={() => desbloquearVendedor(vendedor.id)}
                            disabled={isLoading}
                            className="flex items-center gap-1 px-2 sm:px-3 py-1 text-xs sm:text-sm bg-green-100 text-green-700 hover:bg-green-200 rounded-lg transition-colors disabled:opacity-50"
                          >
                            <UserPlus className="w-3 h-3 sm:w-4 sm:h-4" />
                            <span className="hidden sm:inline">Desbloquear</span>
                          </button>
                        )}
                      </div>

                      {/* Transferir */}
                      <div className="flex items-center gap-1 sm:gap-2">
                        <select
                          className="flex-1 sm:flex-none px-2 sm:px-3 py-1 border border-gray-300 rounded text-xs sm:text-sm focus:ring-2 focus:ring-blue-500 focus:border-transparent min-w-0"
                          onChange={(e) => transferirVendedor(vendedor.id, e.target.value)}
                          disabled={isLoading}
                        >
                          <option value="">Transferir...</option>
                          {gestores
                            .filter(g => g.id !== selectedGestor?.id)
                            .map(gestor => (
                              <option key={gestor.id} value={gestor.id}>
                                {gestor.name}
                              </option>
                            ))}
                        </select>
                      </div>
                    </div>
                  </div>
                ))}
              
              {vendedores.filter(v => v.gestor_id === selectedGestor?.id).length === 0 && (
                <div className="text-center py-6 sm:py-8 text-gray-500">
                  <Users className="w-10 h-10 sm:w-12 sm:h-12 mx-auto mb-2 text-gray-300" />
                  <p className="text-sm sm:text-base">Nenhum vendedor encontrado para este gestor</p>
                </div>
              )}
            </div>
          </div>
        </VendedoresDrawer>

        {/* Modais */}
        <CadastraGestor
          show={exibirModalCadastrarGestores}
          handleClose={handleClose}
          props={props}
          cadastroGestores={cadastroGestores}
        />
        
        <DeletarGestor
          show={exibirModalDeletarGestores}
          handleClose={handleClose}
          handleOpen={handleOpenModalDeletarGestores}
          deletar={excluirGestor}
          id={idGestor}
        />
        
        <DeletarCarteiras
          show={exibirModalDeletarCarteiras}
          handleOpen={handleOpenModalDeletarCarteiras}
          deletarCarteiras={deletarCarteiras}
          gestorId={gestorId}
          status={selectedStatus}
          dataFinal={dataFinal}
          dataInicial={dataInicial}
          handleClose={handleClose}
        />
      </div>
    </>
  );
};

export default VisualizarGestores;